import React, { useState } from 'react';
import './LicensePlateManagement.css';
import LicensePlateList from './LicensePlateList';
import LicensePlateInput from './LicensePlateInput';

const LicensePlateManagement = () => {
  const [activeTab, setActiveTab] = useState('list');

  return (
    <div className="license-plate-management">
      <div className="tabs">
        <button
          className={`tab-button ${activeTab === 'list' ? 'active' : ''}`}
          onClick={() => setActiveTab('list')}
        >
          Danh sách biển số
        </button>
        <button
          className={`tab-button ${activeTab === 'input' ? 'active' : ''}`}
          onClick={() => setActiveTab('input')}
        >
          Nhập biển số mới
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'list' && <LicensePlateList />}
        {activeTab === 'input' && <LicensePlateInput />}
      </div>
    </div>
  );
};

export default LicensePlateManagement;
